import {
  createOptimizedContext,
  useOptimizedContext,
} from "./OptimizedContextProvider";

const createActions = (setAppContext) => ({
  clear: () => setAppContext(undefined),
  setGlobalError: (err) => setAppContext({ globalError: err }),
  setProductData: ({ titleAmount, produto, versao }) =>
    setAppContext({ titleAmount, produto, versao }),
  setPersonalData: (personalData) => setAppContext({ personalData }),
  setProposta: (proposta) => setAppContext({ proposta }),
  setPagamento: (pagamento) => setAppContext({ pagamento }),
});

const { Context, Provider } = createOptimizedContext();

const CONTEXT_KEY = "CONTEXT";

const getInitialContext = () => {
  return {
    ...JSON.parse(sessionStorage.getItem(CONTEXT_KEY) || "{}"),
    globalError: undefined,
  };
};

const AppContextProvider = ({ children }) => {
  return (
    <Provider
      value={getInitialContext()}
      createActions={createActions}
      onUpdate={(context) =>
        sessionStorage.setItem(CONTEXT_KEY, JSON.stringify(context))
      }
    >
      {children}
    </Provider>
  );
};

export const useAppContext = () => {
  return useOptimizedContext(Context);
};

export default AppContextProvider;
